import type { RoadSectionId } from '../../domain/Reference';
import { setSelectedRoadSections } from '../../reference/state';
import { createCommand } from '../../utils';
import { listHoveredIdSet, rightPanelClosed, rightPanelOpened, selectionAnchorSet } from '../state';

// Sets the selection and keeps the right panel in step with it: closed when empty, the object sheet for
// one section, the multi-selection panel for several. `anchor` is where the next Shift-click range starts.
export const SelectRoadSectionsCommand = createCommand<{ ids: RoadSectionId[]; anchor?: RoadSectionId | null }>(
    'MAP_V2/SELECT_ROAD_SECTIONS',
    async ({ ids, anchor }, { dispatch }) => {
        dispatch(setSelectedRoadSections(ids));
        dispatch(listHoveredIdSet(null));
        dispatch(selectionAnchorSet(ids.length === 0 ? null : anchor ?? ids[ids.length - 1] ?? null));
        if (ids.length === 0) {
            dispatch(rightPanelClosed());
        } else {
            dispatch(rightPanelOpened(ids.length === 1 ? 'single' : 'multi'));
        }
    },
);
